import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'routes/path';
import { Form } from 'components/@shared/Form/Form';
import { FormTextField } from 'components/@shared/Form/TextField';
import { Box, Button, Link, Stack, Typography } from '@mui/material';
import { LoginFormData } from 'types/auth';
import { initialValues } from './constants';
import { validationSchema } from './validation';
import { FormPasswordInput } from 'components/@shared/Form/PasswordInput';

interface Props {
    onLogin: (email: string, password: string) => void;
}

const signUpStyles = {
    '&:hover': {
        cursor: 'pointer',
    },
};

export const LoginForm = ({ onLogin }: Props) => {
    const navigate = useNavigate();

    const submitHandler = useCallback(
        ({ email, password }: LoginFormData) => onLogin(email, password),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    const goToForgotPasswordHandler = useCallback(
        () => navigate(PATH.FORGOT_PASSWORD),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    const goToSignUpHandler = useCallback(
        () => navigate(PATH.SIGN_UP),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    return (
        <Form initialValues={initialValues} validationSchema={validationSchema} onSubmit={submitHandler}>
            <Stack gap={2} pt={5} pb={3} maxWidth={380} mx="auto">
                <FormTextField name="email" label="Email" fullWidth size="small" />
                <Box>
                    <FormPasswordInput name="password" label="Password" fullWidth size="small" />
                    <Link component="button" variant="body2" onClick={goToForgotPasswordHandler}>
                        Forgot password?
                    </Link>
                </Box>
                <Button variant="contained" type="submit" fullWidth>
                    Login
                </Button>
                <Typography>
                    Don't have an account?{' '}
                    <Typography
                        component="span"
                        color="primary"
                        fontWeight={600}
                        textAlign="center"
                        sx={signUpStyles}
                        onClick={goToSignUpHandler}
                    >
                        Sign Up
                    </Typography>
                </Typography>
            </Stack>
        </Form>
    );
};
